export const experienceData = [
    {
        id: 1,
        company: 'ElasticRun',
        jobtitle: 'Software Engineer',
        startYear: 'December 2024',
        endYear: 'Present',
        keyPoints: [
            "Building 'Enterprise Vulnerability Management (EVM)', an internal platform to fetch and parse Bandit scan reports via CI pipelines, providing real-time visibility into security vulnerabilities across applications.",
            "Designed features to track monthly and weekly security trends, enabling stakeholders to analyze and reduce recurring vulnerability patterns.",
            "Implemented automated workflows for verifying issue fixes during deployments, improving accuracy and reducing manual effort.",
            "Developed a Consent Management System within SSO, integrated across all applications, ensuring compliance and secure handling of user consents.",
            "Fixed VAPT issues in multiple applications, strengthening the organization’s overall security posture.",
            "Built exception rule handling for false positives, ensuring accurate vulnerability tracking.",
            "Integrated real-time notifications for app owners and developers, improving awareness and response timelines.",
            "Collaborating with cross-functional teams to build and scale a Cyber Awareness Portal for improving organization-wide security culture."
        ]
    },
    {
        id: 2,
        company: 'Actyv.ai',
        jobtitle: 'Software Development Engineer I',
        startYear: 'January 2024',
        endYear: 'September 2024',
        keyPoints: [
            "Led a team of 4 members, ensuring project milestones were achieved and fostering effective team collaboration.",
            "Automated deployment pipelines by integrating DevOps practices, enhancing CI/CD processes and reducing deployment time.",
            "Deployed and managed containerized applications using Kubernetes, optimizing scalability and resource utilization.",
            "Reduced infrastructure costs by 20% through efficient resource management and cost optimization strategies.",
            "Developed a bulk download feature for quarterly e-sign documents within the platform, improving user efficiency.",
            "Implemented a notification broadcasting system, enhancing user engagement by delivering real-time updates.",
            "Optimized platform performance by fine-tuning API response times, resulting in a significant improvement in system speed.",
            "Improved system reliability and uptime by implementing monitoring and alerting solutions using AWS CloudWatch.",
            "Streamlined codebase and enhanced maintainability through the adoption of best practices, resulting in reduced technical debt.",
            "Enhanced security by conducting security audits and implementing fixes for vulnerabilities, ensuring compliance with industry standards."
        ]
    },
    {
        id: 3,
        company: 'Actyv.ai',
        jobtitle: 'Associate Software Development Engineer',
        startYear: 'April 2022',
        endYear: 'December 2023',
        keyPoints: [
            "Engineered a URL shortening service, compressing over 220,000 lengthy URLs to optimize data storage.",
            "Directed the development of a GST loan application for SIB Bank, enabling loans exceeding ₹500 Crore.",
            "Implemented NESL e-sign for Canara Bank's Shishu Mudra application, streamlining digital loan processing.",
            "Resolved critical VAPT issues for Canara Bank, conducting comprehensive security assessments and fixes.",
            "Optimized API performance with complex MongoDB queries, leading to improved response times.",
            "Automated the bulk creation of over 3,000 users via CSV uploads for the SIB GST Loan Application.",
            "Leveraged AWS SQS for asynchronous task handling, optimizing message processing across services.",
            "Generated automated PDFs using Pug templates in Node.js, transforming dynamic data into structured documents."
        ]
    }
];
